module.exports = __webpack_public_path__ + "static/media/time-icon.1db1a76e.svg";